const FORMATTED_VALUE_SUFFIX = '@OData.Community.Display.V1.FormattedValue';

export function readField(record: any, field: string): string | null {
    if (!record) return null;

    const dot = field.indexOf('.');
    if (dot >= 0) {
        const head = field.slice(0, dot);
        const tail = field.slice(dot + 1);
        return readField(record[head], tail);
    }

    const candidateFields = [
        field + FORMATTED_VALUE_SUFFIX,
        field,
        '_' + field + '_value' + FORMATTED_VALUE_SUFFIX,
        '_' + field + '_value',
    ];

    for (const field of candidateFields) {
        if (record.hasOwnProperty(field)) {
            const v= record[field];
            if (v !== null && v !== undefined && v !== '') {
                return String(v);
            } else {
                return null;
            }
        }

    }

    return null;
}
